import { render, staticRenderFns } from "./isFlag.vue?vue&type=template&id=e9c6d24c&scoped=true&"
import script from "./isFlag.vue?vue&type=script&lang=js&"
export * from "./isFlag.vue?vue&type=script&lang=js&"
import style0 from "./isFlag.vue?vue&type=style&index=0&id=e9c6d24c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c6d24c",
  null
  
)

export default component.exports